module.exports = __webpack_public_path__ + "img/1 (87).f11930c5.png";